<div
	class="pv-checkbox"
	[class.disabled]="disabled"
	[class.error]="error"
	[class.has-template]="optionTemplate"
	[class.no-padding]="padding === 'none'"
>
	<label [class.has-template]="optionTemplate">
		<input
			#input
			class="checkbox"
			type="checkbox"
			[checked]="value"
			[class.no-padding]="padding === 'none'"
			[disabled]="disabled"
			(blur)="onTouched()"
			(change)="onChange($any($event).target.checked)"
		/>

		@if (!optionTemplate) {
			<ic-label [help]="help" [required]="required">
				{{ label }}
			</ic-label>
		} @else {
			<ng-template
				[ngTemplateOutlet]="optionTemplate"
				[ngTemplateOutletContext]="{ $implicit: value, disabled: disabled }"
			/>
		}
	</label>
	<ng-content select=".annotations" />
	<ng-content select=".errors" />
</div>
